import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
var RemovePastOrderComponent = /** @class */ (function () {
    function RemovePastOrderComponent(activeModal) {
        this.activeModal = activeModal;
    }
    RemovePastOrderComponent.prototype.ngOnInit = function () {
    };
    RemovePastOrderComponent.prototype.closeModal = function (status) {
        this.activeModal.close(status);
    };
    return RemovePastOrderComponent;
}());
export { RemovePastOrderComponent };



// WEBPACK FOOTER //
// ./src/app/modules/shared/remove-cart-past-order/remove-past-order.component.ts.pre-build-optimizer.js